import Swiper from 'swiper'

const sliderSwiper = () => {
  const settings = {
    grabCursor: true,
    speed: 1000,
    // loop: true,
    autoplay: {
      delay: 3500
    },
    pagination: {
      el: '.swiper-pagination'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }
  const sliders = [...document.querySelectorAll('.js-hero-slider')]
  sliders.map((slider) => new Swiper(slider, settings))
}

export default sliderSwiper
